import React from 'react';
import Root from './src/components/Root';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const wrapRootElement = _ref => {
  let {
    element
  } = _ref;
  return ___EmotionJSX(Root, null, element);
};

// Reset Scroll everytime
export const shouldUpdateScroll = args => {
  window.scrollTo(0, 0);
  return false;
};